import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export default api;

export const getPricing = () => api.get("/settings/pricing").then((r) => r.data);
export const updatePricing = (payload) =>
  api.put("/settings/pricing", payload).then((r) => r.data);
export const resetPricing = () =>
  api.post("/settings/pricing/reset").then((r) => r.data);

export const calculateQuote = (spec) =>
  api.post("/quotes/calculate", spec).then((r) => r.data);

export const saveQuote = (payload) =>
  api.post("/quotes", payload).then((r) => r.data);
export const listQuotes = () => api.get("/quotes").then((r) => r.data);
export const getQuote = (id) => api.get(`/quotes/${id}`).then((r) => r.data);
export const updateQuoteStatus = (id, status) =>
  api.patch(`/quotes/${id}/status`, { status }).then((r) => r.data);
export const deleteQuote = (id) => api.delete(`/quotes/${id}`).then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);

export const getPublicQuote = (token) =>
  api.get(`/public/quotes/${token}`).then((r) => r.data);
export const respondPublicQuote = (token, status) =>
  api.post(`/public/quotes/${token}/respond`, { status }).then((r) => r.data);
export const rotateShareToken = (id) =>
  api.post(`/quotes/${id}/rotate-token`).then((r) => r.data);

export const getEmailStatus = () => api.get("/email/status").then((r) => r.data);
export const sendQuoteEmail = (id, payload) =>
  api.post(`/quotes/${id}/send-email`, payload).then((r) => r.data);
export const previewPdfUrl = (id) => `${API_BASE}/quotes/${id}/preview-pdf`;
export const previewRfqPdfUrl = (id, params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return `${API_BASE}/quotes/${id}/preview-rfq-pdf${qs ? `?${qs}` : ""}`;
};
export const requestRfq = (id, payload) =>
  api.post(`/quotes/${id}/request-rfq`, payload).then((r) => r.data);

export const getReferenceQuotes = () => api.get("/reference-quotes").then((r) => r.data);

export const formatUSD = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(Number(n || 0));
